module.exports = require('./helpers/bundle-url').getBundleURL('dwYZa') + "iron_man.97c262be.png";